import React, { createContext, useContext } from "react";
import { ContestWithId } from "../interfaces/IContests";

interface ContestsContextType {
  contests: ContestWithId[];
}

const ContestsContext = createContext<ContestsContextType | undefined>(undefined);

export default function ContestsProvider({
  contests,
  children,
}: {
  contests: ContestWithId[];
  children: React.ReactNode;
}) {
  return (
    <ContestsContext.Provider
      value={{
        contests,
      }}
    >
      {children}
    </ContestsContext.Provider>
  );
}

export const useContestsContext = (): ContestsContextType => {
  const context = useContext(ContestsContext);
  if (context === undefined) {
    throw new Error("Błąd w ContestsContext: useContests must be used within an ContestsProvider");
  }
  return context;
};
